import { Customers, IndustryType } from "./BrandTrust.types";

import maerskLogo from "./assets/maersk-logo.svg";
import banffLogo from "./assets/Banff-logo.svg";
import ordercoLogo from "./assets/orderco-logo.svg";
import crumbleCookiesLogo from "./assets/Crumble-cookies-logo.svg";
import hiltonLogo from "./assets/hilton-logo.svg";
import coreYogaLogo from "./assets/Core-Yoga-Logo.svg";
import rutgersLogo from "./assets/Rutgers-logo.svg";
import montgomeryAcademyLogo from "./assets/Montgomery-Academy.svg";
import nationSafeDriversLogo from "./assets/Nation-Safe-Drivers-Logo.svg";
import intelyCareLogo from "./assets/IntelyCare-Logo.svg";
import bgLogo from "./assets/BG-Logo.svg";
import chickfilaLogo from "./assets/chickfila-logo.svg";
import fluidTruckLogo from "./assets/FluidTruck-Logo.svg";
import nbaLogo from "./assets/NBA-logo.svg";
import usSoccerLogo from "./assets/US-Soccer-Logo.svg";
import ursaMajorLogo from "./assets/Ursa-Major-Logo.svg";
import zohoLogo from "./assets/Zoho-Logo.svg";
import hogsaltLogo from "./assets/Hogsalt.svg";
import appleLogo from "./assets/apple-logo.svg";
import cloudkitchensLogo from "./assets/cloudkitchens-logo.svg";
import fedexForumLogo from "./assets/FedExForum.svg";
import spinosoGroupLogo from "./assets/Spinoso-Group-Logo.svg";
import planetLogo from "./assets/Planet-logo.svg";
import bayCollegeLogo from "./assets/bay-college.svg";
import doleLogo from "./assets/dole-logo.svg";
import universityOfVirginiaLogo from "./assets/university-of-virginia-logo.svg";
import hawaiiAcademyLogo from "./assets/hawaii-academy.svg";
import lakeLouiseLogo from "./assets/Lake-Louise-Logo.svg";
import mountUnivLogo from "./assets/Mount-Univ-Logo.svg";
import autinLogo from "./assets/Autin-Logo.svg";
import columbiaUniversityLogo from "./assets/columbia-univeristy-logo.svg";
import koaLogo from "./assets/KOA-logo.svg";
import microsoftLogo from "./assets/microsoft-logo.svg";
import topGolfLogo from "./assets/TopGolf-logo.svg";
import winterParkLogo from "./assets/WinterPark-Logo.svg";
import baseballLogo from "./assets/baseball-logo.svg";
import pax8Logo from "./assets/Pax8-Logo.svg";
import ventureGlobalLngLogo from "./assets/Venture-Global-LNG.svg";
import humaneLogo from "./assets/Humane-Logo.svg";
import nasaLogo from "./assets/nasa-logo.svg";
import lexisLogo from "./assets/lexis-logo.svg";
import evoLogo from "./assets/EVO-logo.svg";
import hamptonLogo from "./assets/hampton-logo.svg";
import kunesLogo from "./assets/kunes-logo.svg";
import drakeswLogo from "./assets/drakesw-logo.svg";
import johnsonUnivLogo from "./assets/Johnson-Univ-Logo.svg";
import hardinJeffersonLogo from "./assets/Hardin-Jefferson-logo.svg";
import sandboxvrLogo from "./assets/sandboxvr-logo.svg";
import microCenterLogo from "./assets/micro-center-logo.svg";

export const customerData: Customers[] = [
  {
    name: "MAERSK",
    industryType: IndustryType.MissionCritical,
    logo: maerskLogo,
  },
  {
    name: "Banff Sunshine",
    industryType: IndustryType.Hospitality,
    logo: banffLogo,
  },
  {
    name: "Order.co",
    industryType: IndustryType.EnterpriseOffice,
    logo: ordercoLogo,
  },
  {
    name: "Crumbl Cookies",
    industryType: IndustryType.Retail,
    logo: crumbleCookiesLogo,
  },
  {
    name: "Hilton Grand Vacations",
    industryType: IndustryType.Hospitality,
    logo: hiltonLogo,
  },
  {
    name: "CorePower Yoga",
    industryType: IndustryType.Retail,
    logo: coreYogaLogo,
  },
  {
    name: "Rutgers University",
    industryType: IndustryType.Education,
    logo: rutgersLogo,
  },
  {
    name: "Montgomery Bell Academy",
    industryType: IndustryType.Education,
    logo: montgomeryAcademyLogo,
  },
  {
    name: "ONSD",
    industryType: IndustryType.EnterpriseOffice,
    logo: nationSafeDriversLogo,
  },
  {
    name: "IntelyCare",
    industryType: IndustryType.EnterpriseOffice,
    logo: intelyCareLogo,
  },
  {
    name: "Bergdorf Goodman",
    industryType: IndustryType.Retail,
    logo: bgLogo,
  },
  {
    name: "Chick-Fil-A",
    industryType: IndustryType.Retail,
    logo: chickfilaLogo,
  },
  {
    name: "Fluidtruck",
    industryType: IndustryType.EnterpriseOffice,
    logo: fluidTruckLogo,
  },
  {
    name: "National Basketball Association",
    industryType: IndustryType.EnterpriseOffice,
    logo: nbaLogo,
  },
  {
    name: "US Soccer",
    industryType: IndustryType.EnterpriseOffice,
    logo: usSoccerLogo,
  },
  {
    name: "Ursa Major Technologies",
    industryType: IndustryType.MissionCritical,
    logo: ursaMajorLogo,
  },
  {
    name: "Zoho Corp",
    industryType: IndustryType.EnterpriseOffice,
    logo: zohoLogo,
  },
  {
    name: "Hogsalt Hospitality",
    industryType: IndustryType.Hospitality,
    logo: hogsaltLogo,
  },
  {
    name: "Apple",
    industryType: IndustryType.EnterpriseOffice,
    logo: appleLogo,
  },
  {
    name: "CloudKitchens",
    industryType: IndustryType.Retail,
    logo: cloudkitchensLogo,
  },
  {
    name: "FedExForum",
    industryType: IndustryType.EnterpriseOffice,
    logo: fedexForumLogo,
  },
  {
    name: "Spinoso Real Estate Group",
    industryType: IndustryType.Retail,
    logo: spinosoGroupLogo,
  },
  {
    name: "Micro Center",
    industryType: IndustryType.Retail,
    logo: microCenterLogo,
  },
  {
    name: "Bay College",
    industryType: IndustryType.Education,
    logo: bayCollegeLogo,
  },
  {
    name: "Dole",
    industryType: IndustryType.EnterpriseOffice,
    logo: doleLogo,
  },
  {
    name: "University of Virginia",
    industryType: IndustryType.Education,
    logo: universityOfVirginiaLogo,
  },
  {
    name: "Hawai'i Preparatory Academy",
    industryType: IndustryType.Education,
    logo: hawaiiAcademyLogo,
  },
  {
    name: "Lake Louise Ski Resort",
    industryType: IndustryType.Hospitality,
    logo: lakeLouiseLogo,
  },
  {
    name: "Mount St. Mary's University",
    industryType: IndustryType.Education,
    logo: mountUnivLogo,
  },
  {
    name: "Microsoft",
    industryType: IndustryType.EnterpriseOffice,
    logo: microsoftLogo,
  },
  {
    name: "TopGolf",
    industryType: IndustryType.Hospitality,
    logo: topGolfLogo,
  },
  {
    name: "Winter Park Resort",
    industryType: IndustryType.Hospitality,
    logo: winterParkLogo,
  },
  {
    name: "Major League Baseball",
    industryType: IndustryType.EnterpriseOffice,
    logo: baseballLogo,
  },
  {
    name: "pax8",
    industryType: IndustryType.EnterpriseOffice,
    logo: pax8Logo,
  },
  {
    name: "Venture Global LNG",
    industryType: IndustryType.MissionCritical,
    logo: ventureGlobalLngLogo,
  },
  {
    name: "Humane",
    industryType: IndustryType.EnterpriseOffice,
    logo: humaneLogo,
  },
  {
    name: "NASA / Ames Research Center",
    industryType: IndustryType.MissionCritical,
    logo: nasaLogo,
  },
  {
    name: "LexisNexis",
    industryType: IndustryType.EnterpriseOffice,
    logo: lexisLogo,
  },
  {
    name: "EVO",
    industryType: IndustryType.Hospitality,
    logo: evoLogo,
  },
  {
    name: "Hampton Farms",
    industryType: IndustryType.EnterpriseOffice,
    logo: hamptonLogo,
  },
  {
    name: "Kunes",
    industryType: IndustryType.Retail,
    logo: kunesLogo,
  },
  {
    name: "DrakeSoftware",
    industryType: IndustryType.EnterpriseOffice,
    logo: drakeswLogo,
  },
  {
    name: "Planet",
    industryType: IndustryType.EnterpriseOffice,
    logo: planetLogo,
  },
  {
    name: "AUSTIN COLLEGE",
    industryType: IndustryType.Education,
    logo: autinLogo,
  },
  {
    name: "Columbia University",
    industryType: IndustryType.Education,
    logo: columbiaUniversityLogo,
  },
  {
    name: "KOA (campgrounds)",
    industryType: IndustryType.Hospitality,
    logo: koaLogo,
  },
  {
    name: "Johnson University",
    industryType: IndustryType.Education,
    logo: johnsonUnivLogo,
  },
  {
    name: "Hardin Jefferson Independent School District",
    industryType: IndustryType.Education,
    logo: hardinJeffersonLogo,
  },
  {
    name: "SandboxVR",
    industryType: IndustryType.EnterpriseOffice,
    logo: sandboxvrLogo,
  },
];
